import { FormatValue } from '@plato/ui-legacy/components/ui/format-value';
import { useInterceptRef } from '@plato/ui-legacy/lib/hooks/use-intercept-ref';
import { cn } from '@plato/ui/util/classes';
import { Slot } from '@radix-ui/react-slot';
import type { ForwardedRef, InputHTMLAttributes, ReactNode } from 'react';
import { forwardRef } from 'react';

type InputProps = InputHTMLAttributes<HTMLInputElement>;

export type OverlayInputProps = InputProps & {
    children?: ReactNode;
    containerClassName?: string;
    hideOverlay?: boolean;
    overlay?: ReactNode;
};

export const OverlayInput = forwardRef(
    (
        { children, containerClassName, overlay, hideOverlay, ...inputProps }: OverlayInputProps,
        forwardedRef: ForwardedRef<HTMLInputElement>,
    ) => {
        const overlayProps = { value: inputProps.value };
        const [internalRef, setRef] = useInterceptRef<HTMLInputElement>(forwardedRef);
        const Input = children ? Slot : 'input';
        const Overlay = overlay ? Slot : FormatValue;

        return (
            <div className={cn('relative group bg-white', containerClassName)}>
                <Input ref={setRef} {...inputProps}>
                    {children}
                </Input>
                <div
                    className={cn(
                        'absolute top-0 left-0 right-0 bottom-0 bg-inherit',
                        'group-focus-within:hidden',
                        hideOverlay && 'hidden',
                    )}
                    onClick={() => {
                        internalRef.current?.focus();
                    }}
                >
                    <Overlay {...overlayProps}>{overlay}</Overlay>
                </div>
            </div>
        );
    },
);

OverlayInput.displayName = 'OverlayInput';
